import {
  OriginatorDating,
  OriginatorEvent,
  OriginatorIdentifier,
  OriginatorName,
} from 'types';

const originKeyLabels: Record<keyof OriginatorDating, string> = {
  date: 'Datace vzniku',
  methodLabel: 'Způsob vzniku',
};

const endingKeyLabels: Record<keyof OriginatorDating, string> = {
  date: 'Datace zániku',
  methodLabel: 'Způsob zániku',
};

const eventKeyLabels: Record<keyof OriginatorEvent, string> = {
  studyStatusLabel: 'Stav studia',
  typeLabel: 'Typ události',
  begin: 'Datace události od',
  end: 'Datace události do',
  note: 'Poznámka',
};

export const identificatorsKeyLabels: Record<
  keyof OriginatorIdentifier,
  string
> = {
  typeLabel: 'Zdroj externího identifikátoru',
  value: 'Hodnota externího identifikátoru',
  validFrom: 'Platnost externího identifikátoru od',
  validTo: 'Platnost externího identifikátoru do',
  verified: 'Hodnota externího identifikátoru ověřena',
};

const nameKeyLabels: Record<keyof OriginatorName, string> = {
  degreeAfter: 'Titul za jménem',
  degreeBefore: 'Titul před jménem',
  generalSupplement: 'Obecný doplněk',
  chronologicalSupplement: 'Chronologický doplněk',
  geoSupplement: 'Geografický doplněk',
  primaryPart: 'Hlavní část jména',
  secondaryPart: 'Vedlejší část jména',
  typeLabel: 'Typ formy jména',
  originalLanguagesLabels: 'Jazyk jména',
};

export const registerKeyLabels = {
  origin: originKeyLabels,
  ending: endingKeyLabels,
  event: eventKeyLabels,
  name: nameKeyLabels,
  identificators: identificatorsKeyLabels,
};
